import formatFileSize from './format-filesize';
import fileTypeMapper from './file-type-mapper';

export default class FileHelper {
    typeMapper = fileTypeMapper;

    constructor (limitTypes = [], limitSize = null) {
        this.limitTypes = limitTypes;
        this.limitSize = limitSize;
        this.errorMessages = [];
        this.validators = [
            this.isTypeValid,
            this.isSizeValid
        ];
        // 部分检测器需要在检测完成后进行善后工作
        this.aftermathFunctions = [];

        this.mimeLimitTypes = [];
        for (const index in limitTypes) {
            this.mimeLimitTypes.push(this.typeMapper[limitTypes[index].toLowerCase()]);
        }
    }

    isValid = async (file) => {
        this.clearErrorMessages();
        const promises = [];
        for (const index in this.validators) {
            promises.push(this.validators[index](file));
        }
        return Promise.all(promises).then(results => {
            this.aftermath();
            if (results.indexOf(false) > -1) {
                return false;
            } else {
                return true;
            }
        });
    };

    isTypeValid = async (file) => {
        const fileType = file.type;
        // console.log(file)
        // console.log(this.mimeLimitTypes)
        if (0 === this.mimeLimitTypes.length) return true;
        const fileTypeLowerCase = fileType.toLowerCase();
        if (this.mimeLimitTypes.indexOf(fileTypeLowerCase) > -1) {
            return true;
        } else {
            this.addErrorMessage(`文件类型不符合要求：需要 ${this.limitTypes.join(',')}`);
            return false;
        }
    };

    isSizeValid = async (file) => {
        if (null === this.limitSize) return true;
        const fileSize = file.size;
        if (fileSize <= this.limitSize) {
            return true;
        } else {
            this.addErrorMessage(`文件大小不符合要求：需要不大于 ${formatFileSize(this.limitSize)}`);
            return false;
        }
    };

    addErrorMessage (message) {
        this.errorMessages.push(message);
    }

    clearErrorMessages () {
        this.errorMessages = [];
    }

    aftermath () {
        for (const index in this.aftermathFunctions) {
            this.aftermathFunctions[index]();
        }
    }
}
